
 export enum DeleteActions {
    deleteSubject = 1,
    deleteSubjectSet = 2
  }